/* LOVEQUEEN - トップ動画の日付（テーマ設定でオンの時だけ表示） */
(function () {
  'use strict';
  var cfg = document.documentElement.dataset;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function init() {
    if (cfg.lqStamp !== '1') return;
    var hero = document.querySelector('.lqh'); if (!hero || hero.querySelector('.lq-y2k-stamp')) return;
    var t = (cfg.lqStampText || '').trim();
    if (!t) { var d = new Date(); t = "'" + String(d.getFullYear()).slice(2) + ' ' + (d.getMonth() + 1) + ' ' + pad(d.getDate()); }
    var s = document.createElement('div'); s.className = 'lq-y2k-stamp'; s.textContent = t; hero.appendChild(s);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
